<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div id='map' class='big-two-map-box'></div>
</template>
<script>
import world from "./world.json";
import * as echarts from "echarts";
import {getFlatCountry} from "@/service/dashboard";
import {countryDict, countryChineseDict} from "@/theme/dict";
export default {
  props: ["btnListValue"],
  data() {
    return {
      myChart: null,
      buttonList:
                {
                  "all": "总览",
                  "pki": "证书",
                  "bgp": "路由",
                  "web": "网站",
                  "dns": "域名",
                  "email": "邮件"
                },
      unitManagementData: [],
      mapLineDataArr: [],
      option3: {
        // 鼠标移上去时显示悬浮框
        tooltip: {
          backgroundColor: "#929edc",
          padding: 8,
          trigger: "item", // 设置该属性之后，会与series中data数据对应。注意data中对象的键名为name。如果单纯的展示数据可用此属性，不与formatter同用。
          // 模板字符串渲染悬浮框，注意图片的引入方式（require）,否则无法显示。
          position: function (point) {
            // point 参数包含了数据点的坐标信息
            return [point[0] + 10, point[1] - 10]; // 根据数据点坐标调整位置
          },
          formatter: (params) => {
            if (params.data && params.data[this.btnListValue]) {
              return `<div style="text-align: center;">
                      <p>国家:${countryChineseDict[params.name]}</p>
                      <p>国家评分:${params.value}</p>
                      <p>基础设施类型:${this.buttonList[this.btnListValue]}</p>
                      <p>资产数量:${params.data[this.btnListValue].asset_num}</p>
                      <p>漏洞数量:${params.data[this.btnListValue].asset_prac}</p>
                    <div>`;
            }
            return `<div style="text-align: center;">
                      <p>国家:${countryChineseDict[params.name]}</p>
                      <p>国家评分:${params.value}</p>
                      <p>基础设施类型:${this.buttonList[this.btnListValue]}</p>
                      <p>资产数量:0</p>
                      <p>漏洞数量:0</p>
                    <div>`;

          }
        },
        // <p v-if="arr.email">基础设施类型:邮件</p>
        // <p v-if="arr.email">资产数量:${params.data.email.asset_num}</p>
        // <p v-if="arr.email">漏洞数量:${params.data.email.asset_prac}</p>
        // <p v-if="arr.web">基础设施类型:网站</p>
        // <p v-if="arr.web">资产数量:${params.data.web.asset_num}</p>
        // <p v-if="arr.web">漏洞数量:${params.data.web.asset_prac}</p>
        // <p v-if="arr.pki">基础设施类型:证书</p>
        // <p v-if="arr.pki">资产数量:${params.data.pki.asset_num}</p>
        // <p v-if="arr.pki">漏洞数量:${params.data.pki.asset_prac}</p>
        // <p v-if="arr.bgp">基础设施类型:路由</p>
        // <p v-if="arr.bgp">资产数量:${params.data.bgp.asset_num}</p>
        // <p v-if="arr.bgp">漏洞数量:${params.data.bgp.asset_prac}</p>
        // 视觉映射组件
        visualMap: [{
          show: false,
          type: "continuous", // 类型为连续型
          min: 60,
          max: 100,
          // range: [5, 10],
          left: "left",
          top: "bottom",
          text: ["高", "低"], // 取值范围的文字
          textStyle: {
            color: "#fff"
          },
          inRange: {
            color: ["rgb(216,209,243)", "#4910b9"] // 取值范围的颜色
          }
        }],

        series: [
          {
            type: "map",
            name: "降水量",
            map: "world", // 这里的名称需要和 echarts.registerMap('china',{})中的名称一致
            roam: true, // 缩放
            zlevel: 1, // 设置图层堆叠顺序
            zoom: 1.2, // 默认地图在容器中显示zoom:1,可根据需求放大缩小地图
            label: {
              show: false, // 是否显示省份名称
              color: "#fff"
            },
            itemStyle: {
              areaColor: "#252531", // 地图区域背景颜色
              borderColor: "#ffffff" // 地图边界颜色
            },
            // 高亮时的设置
            emphasis: {
              // 高亮时地图区域背景颜色
              itemStyle: {
                areaColor: "pink"
              },
              // 文字颜色，样式在此处
              label: {
                color: "#fff"
              }
            },
            data: []
          }

        ]
      }
    };
  },
  mounted(){
    // this.getData();
  },
  watch: {
    btnListValue() {
      this.myChart.setOption(this.option3);
    }
  },
  methods: {
    getData(){
      getFlatCountry().then(res =>{
        console.log(res);
        const countryArr = Object.keys(res);
        const resultArr = countryArr.map(item => {
          return {
            ...res[item],
            name: countryDict[item],
            value: res[item].score ? res[item].score: 0
          };
        });
        // let cnData = res.CN;
        //  cnData.name = "China";
        //  let usData = res.BG;
        //  usData.name = "Russia";
        //  let dsData = res.TH;
        //  dsData.name = "Serbia";
        //  let resData = [];
        //  resData.push(cnData);
        //  resData.push(usData);
        //  resData.push(dsData);
        //
        //  let newArray = resData.map(item => ({
        //    ...item,
        //    type:"dns",
        //    value: item.score // 重命名 'score' 为 'value'
        //  }));

        console.log(resultArr);
        this.option3.series[0].data = resultArr;
        this.init();
      });
    },
    init() {
      echarts.registerMap("world", world);
      const dom = document.getElementById("map");

      this.myChart = echarts.init(dom);

      this.myChart.setOption(this.option3);
      // this.startTooltipRotation();

    },
    startTooltipRotation() {
      let index2 = 0; // 初始索引为0

      let dataLength = this.option3.series[0].data.length;

      let timer = "";
      const startRotation =()=>{
        timer = setInterval(() => {
          if (dataLength > 0) {
            this.myChart.dispatchAction({
              type: "hideTip"
            });

            this.myChart.dispatchAction({
              type: "showTip",
              seriesIndex: 0,
              dataIndex: index2
            });

            index2 = (index2 + 1) % dataLength; // 使用取余确保循环
          }
        }, 5000);
      };

      // 鼠标移入停止轮播
      this.myChart.on("mouseover", () => {
        clearInterval(timer); // 清除定时器停止轮播
      });

      // 鼠标移出继续轮播
      this.myChart.on("mouseout", () => {
        clearInterval(timer); // 清除定时器停止轮播
        startRotation(); // 重新启动轮播
      });

      // 初始启动轮播
      startRotation();
    }
  }
};

</script>
<style scoped lang='less'>
.big-two-map-box {
  width: 900px;
  height: 440px;
  position: absolute;
  left: 27%;
  top: 28%;
}
</style>
